import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";

/**
 * The ProductsList component renders a list of products associated with a supplier.
 *
 * If the data is still loading, it displays the "Loading..." message.
 * If there are no products added to the supplier, it displays the "No products added to this supplier" message.
 * Otherwise, it renders a list of products, each with a link to edit the product.
 * The products are styled with a card component, with a rounded corner and a shadow effect on hover.
 *
 * @param {object} props - component props
 * @param {object} props.supplier - The supplier object.
 * @param {Array} props.productsMaster - The array of products associated with the supplier.
 */
export default function ProductsList({ supplier, productsMaster }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detect mobile screen size

  return (
    <div>
      {!supplier && !productsMaster ? (
        <p>Loading...</p>
      ) : (
        <>
          <div>
            {productsMaster.length === 0 && (
              <p>No products added to this supplier</p>
            )}
          </div>
          <Grid
            container
            justifyContent="center"
            alignContent="center"
            spacing={1}
          >
            {productsMaster.map(product => (
              <Grid item xs={12} md={6} sm={4} lg={4} key={product.id}>
                <Link to={`/edit-product/${supplier.id}/${product.id}`}>
                  <Card
                    style={{
                      borderRadius: "16px", // Set the card rounding
                      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", // Initial shadow
                      transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth transition for hover effects
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.transform = "scale(1.03)";
                      e.currentTarget.style.boxShadow =
                        "0px 6px 16px rgba(0, 0, 0, 0.2)";
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow =
                        "0px 4px 12px rgba(0, 0, 0, 0.1)";
                    }}
                  >
                    <CardContent
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        height: 120,
                        borderRadius: "16px", // Set the card rounding
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", // Initial shadow
                        transition: "transform 0.3s ease, box-shadow 0.3s ease", // Smooth transition for hover effects
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid
                          item
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={supplier.logo_url}
                            alt={supplier.supplier_name}
                            width={100}
                          />
                        </Grid>
                        <Grid
                          item
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div>
                            <Typography
                              variant="h6"
                              style={{
                                fontWeight: "bold",

                                overflow: isMobile ? "hidden" : "visible",
                                textOverflow: isMobile ? "ellipsis" : "unset",
                                whiteSpace: isMobile ? "nowrap" : "normal",
                                width: isMobile ? "180px" : "auto",
                              }}
                            >
                              {product.display_name}
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              color={
                                product.refs_product_status_id &&
                                product.refs_product_status_id.id === 1
                                  ? "primary"
                                  : "error"
                              }
                            >
                              {!product.refs_product_status_id
                                ? "Unknown Status - Please Update"
                                : product.refs_product_status_id.status_name}
                            </Typography>
                            <Typography>
                              {`R ${(
                                product.customer_price_vat_excl * 1.15
                              ).toFixed(2)}`}
                            </Typography>
                          </div>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Link>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </div>
  );
}
